import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { loadTags, loadTagsWithFree } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var BusinessAmenitiesComponent = /** @class */ (function () {
    function BusinessAmenitiesComponent(_toggleService, _editAmenitiesDialog, snackBar, _businessManagerService) {
        this._toggleService = _toggleService;
        this._editAmenitiesDialog = _editAmenitiesDialog;
        this.snackBar = snackBar;
        this._businessManagerService = _businessManagerService;
        this._lineServiceTags = [];
        this._amenitiesTags = [];
        this._internetTags = [];
        this._transportationTags = [];
        this.editModeSet = false;
        this._creditCardTags = [];
        this.isRegionalManager = false;
    }
    BusinessAmenitiesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadAllTags();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "hasContent", {
        get: function () {
            return (this._lineServiceTags.length > 0 || this._amenitiesTags.length > 0 ||
                this._internetTags.length > 0 || this._transportationTags.length > 0 ||
                this._creditCardTags.length > 0 || this.editModeSet);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "lineServiceTags", {
        get: function () {
            return this._lineServiceTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "amenitiesTags", {
        get: function () {
            return this._amenitiesTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "internetTags", {
        get: function () {
            return this._internetTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "transportationTags", {
        get: function () {
            return this._transportationTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "creditCardTags", {
        get: function () {
            return this._creditCardTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessAmenitiesComponent.prototype, "creditCards", {
        get: function () {
            var result = [];
            for (var _i = 0, _a = this.business.tags; _i < _a.length; _i++) {
                var currentTag = _a[_i];
                if (currentTag.tagName.startsWith('Credit Cards::')) {
                    result.push(currentTag.displayName);
                }
            }
            return result.sort();
        },
        enumerable: true,
        configurable: true
    });
    BusinessAmenitiesComponent.prototype.loadAllTags = function () {
        // Load Line Service
        this._lineServiceTags = loadTags(this.business.tags, 'Line Services::', '', '');
        // Load Amenities
        this._amenitiesTags = loadTags(this.business.tags, 'Amenities::', '', 'Amenities::Internet');
        // Load Internet
        this._internetTags = loadTagsWithFree(this.business.tags, 'Amenities::Internet::');
        // Load Transportation
        this._transportationTags = loadTagsWithFree(this.business.tags, 'Transportation::');
        // Load Credit Cards
        this._creditCardTags = loadTags(this.business.tags, 'Credit Cards::', '', '');
    };
    /**
     * Opens modal for editing business overview section, displays snackbar if serverAPI was successfully updated.
     */
    BusinessAmenitiesComponent.prototype.openEditLandingDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editAmenitiesDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            // Load Line Service
            if (isSuccess) {
                _this.loadAllTags();
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return BusinessAmenitiesComponent;
}());
export { BusinessAmenitiesComponent };
